module.exports = __webpack_public_path__ + "img/SMP_profil-287890574-1400x900.39759fdd.jpg";